"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDefaultUnmanagedMetadata = buildDefaultUnmanagedMetadata;
const ClassElementMetadataKind_1 = require("../models/ClassElementMetadataKind");
function buildDefaultUnmanagedMetadata() {
    return {
        kind: ClassElementMetadataKind_1.ClassElementMetadataKind.unmanaged,
    };
}
//# sourceMappingURL=buildDefaultUnmanagedMetadata.js.map